<div class="widget" [style.border-left]="border ? '5px solid #EA5046' : ' '">
  <div class="amSuite-widget-header">
    {{ 'widgets.partyprofile-expiredcompetence.title' | translate }}
  </div>

  <div class="amSuite-widget-block height-auto">
    <div>
      @switch (status) {
      @case ('ok') {
      <div>
        @if (haveCmp()) {
        @for (com of expiringCmp; track $index) {
        @if (com) {
        <div class="reqnew">
          @if (com.res != null || (com.res !=null && com.res.length != 0)) {
          <strong>{{com.name | uppercase}} :
          </strong>
          }
          <div class="flt-rt">
            @if (com.res != null && com.res.length <= 0) { <div>
              <i class="fa fa-check" aria-hidden="true" style="color:green"></i>
          </div>
          }
        </div>
        <!-- <hr *ngIf="com.res != null || (com.res !=null && com.res.length != 0)"> -->
      </div>
      @if (com.res != null && com.res.length > 0) {
      <table class="table table-sm tab-gen">
        <thead>
          <tr>
            <th>{{ 'widgets.partyprofile-expiredcompetence.name' | translate }}</th>
            <th>{{ 'widgets.partyprofile-expiredcompetence.competence' | translate }}</th>
            <th>{{ 'widgets.partyprofile-expiredcompetence.level' | translate }}</th>
            <th>{{ 'widgets.partyprofile-expiredcompetence.expiredDate' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (p of com.res; track $index) {
          <tr>
            <td>
              {{ p.fullName }}
            </td>
            <td pTooltip="{{p.skillCategory.skillGroup.name}}">{{p.skillCategory.name}}
            </td>
            <td>{{p.skillLevel.name}}</td>
            <td>{{p.expirationDate | date: 'shortDate'}}</td>
          </tr>
          }
        </tbody>
      </table>
      }
      }
      }
      }
      @if (!haveCmp()) {
      <p>{{ 'app.noData' | translate }}</p>
      }
    </div>
    }
    @case ('busy') {
    <div>
      <p>
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        {{'app.loading-message'| translate}}
        <span class="sr-only"></span>
      </p>
    </div>
    }
    }
  </div>
</div>
</div>